import styled from '@emotion/styled';
import { Button, Flex } from '@pairy/pds-react';

export const InputWrapper = styled(Flex)`
  width: 100%;
`;

export const CreateButton = styled(Button)`
  height: fit-content;
  flex-grow: 1;
  flex-shrink: 0;
`;
